import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Figma "Toast" on the not-set-up Texting page (2563:8149): warning surface, Body2 copy, and a
// medium primary button.
export const styles = (theme: Theme) => {
	return ({
		root: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			padding: theme.spacing(2),
			borderRadius: 4,
			backgroundColor: theme.palette.custom.tagWarningSurface,
		},
		icon: {
			flexShrink: 0,
			color: theme.palette.custom.tagWarningText,
		},
		text: {
			flex: "1 0 0",
			minWidth: 0,
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		button: {
			flexShrink: 0,
			height: 36,
			boxSizing: "border-box",
		},
	} satisfies Record<string, CSSObject>);
};
